<template>
  <div>
    <div class="dorm-tab__list">
      <div
        v-for="person in persons"
        :key="person.id"
        class="dorm-tab__col col-xl-3 col-lg-3 col-md-3"
        :class="{
        'col-xl-12 col-lg-12 col-md-12 col-sm-12' : person.banners && person.banners.length > 0,
        empty : person.banners && person.banners.length <= 0
      }">
        <person-card :actor="person" v-if="!person.banners"/>
        <div class="banner-section row" v-if="person.banners">
          <banner-item
            class="col-xl-6 col-lg-6 col-md-12 col-sm-12"
            v-for="banner in banners" :key="banner.id"
            :banner="banner"
            :to="{ name: 'ActorDetail', params: { slug: banner.dorm.slug, id: banner.dorm_id }}"
          />
        </div>
      </div>
      <empty-content :content="emptyContent" v-if="persons.length === 0"/>
    </div>
  </div>
</template>

<script>
import PersonCard from '@/components/PersonCard'
import BannerItem from '@/components/BannerItem'
export default {
  name: 'PersonList',
  props: {
    persons: Array
  },
  components: {
    PersonCard,
    BannerItem
  },
  data () {
    return {
      emptyContent: {
        icon: 'icon-search',
        title: 'No Result!',
        text: 'Hollywood celebrities. Hollywood celebrites are close to you more than ever!'
      }
    }
  }
}
</script>

<style scoped>

</style>
